import dryVanDiagram from './dry-van-diagram.jpg';
import flatBedDiagram from './flat-bed-diagram.png';
import boxTruckDiagram from './box-truck-diagram.png';
import bobtailDiagram from './bobtail-diagram.png';

// the PDF embeds the same image backend-side (see RentalTrailerTypes DiagramAsset)
export const RENTAL_TRAILER_DIAGRAMS: Record<string, string> = {
  dryVan: dryVanDiagram,
  flatBed: flatBedDiagram,
  boxTruck: boxTruckDiagram,
  bobtail: bobtailDiagram,
};
